
import { Heart, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "wouter";
import googlePlayBadge from "@assets/Get_it_on_Android-removebg-preview_1772599859501.png";

export function Footer() {
  return (
    <footer className="hidden md:block bg-slate-900 text-white mt-auto relative">
      {/* Footer Owl Mascot - Desktop Only */}
      <div className="hidden md:block absolute bottom-4 right-8 animate-gentle-pulse">
        <img 
          src="/owl-mascot.svg" 
          alt="HealthyOwl mascot" 
          className="w-16 h-16 opacity-70 hover:opacity-100 transition-opacity duration-300"
        />
      </div>

      <div className="container mx-auto px-4 py-6">
        {/* Mobile: Compact Footer */}
        <div className="md:hidden flex flex-col items-center justify-center space-y-3 text-center">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-2">
            <div className="w-6 h-6 flex items-center justify-center">
              <img src="/owl-logo.png" alt="HealthyOwl Logo" className="h-6 w-6 object-contain" />
            </div>
            <span className="text-lg font-bold">Healthy Owl</span>
          </div>

          {/* Quick Links - Compact */}
          <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-slate-300">
            <Link href="/about" className="hover:text-white transition-colors">About</Link>
            <span className="text-slate-600">•</span>
            <Link href="/contact" className="hover:text-white transition-colors">Contact</Link>
            <span className="text-slate-600">•</span>
            <Link href="/about-health-ai" className="hover:text-white transition-colors">Health AI</Link>
            <span className="text-slate-600">•</span>
            <Link href="/terms-privacy-policy" className="hover:text-white transition-colors">Privacy Policy & Terms</Link>
          </div>

          {/* Made with love */}
          <div className="flex items-center space-x-2 text-slate-300">
            <Heart className="w-3 h-3 text-red-500" />
            <span className="text-xs">Made with love in India</span>
          </div>

          {/* Copyright */}
          <div className="text-slate-400 text-xs">
            © 2025 The Owl Co. All rights reserved.
          </div>
        </div>

        {/* Desktop: Comprehensive Footer */}
        <div className="hidden md:block">
          <div className="grid grid-cols-4 gap-8 mb-6">
            {/* Column 1: Brand */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img src="/owl-logo.png" alt="HealthyOwl Logo" className="h-8 w-8 object-contain" />
                <span className="text-xl font-bold">Healthy Owl</span>
              </div>
              <p className="text-slate-300 text-sm mb-4">
                Your trusted partner for mental wellness and holistic health.
              </p>
              <div className="flex items-center space-x-2 text-slate-300">
                <Heart className="w-4 h-4 text-red-500" />
                <span className="text-sm">Made with love in India</span>
              </div>
              <a href="https://play.google.com/store/apps/details?id=in.healthyowl.app" target="_blank" rel="noopener noreferrer" className="inline-block mt-4">
                <img src={googlePlayBadge} alt="Get it on Google Play" className="h-20 hover:opacity-80 transition-opacity" />
              </a>
            </div>

            {/* Column 2: Services */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Services</h3>
              <ul className="space-y-2">
                <li>
                  <Link href="/ai-health-session" className="text-slate-300 hover:text-white transition-colors text-sm">
                    HealthyOwl AI Mitr
                  </Link>
                </li>
                <li>
                  <Link href="/booking" className="text-slate-300 hover:text-white transition-colors text-sm">
                    Calm Sounds
                  </Link>
                </li>
                <li>
                  <Link href="/mindfulness" className="text-slate-300 hover:text-white transition-colors text-sm">
                    Mindfulness
                  </Link>
                </li>
                <li>
                  <Link href="/booking" className="text-slate-300 hover:text-white transition-colors text-sm">
                    Book Session
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Company */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Company</h3>
              <ul className="space-y-2">
                <li>
                  <Link href="/about" className="text-slate-300 hover:text-white transition-colors text-sm">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link href="/contact" className="text-slate-300 hover:text-white transition-colors text-sm">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link href="/about-health-ai" className="text-slate-300 hover:text-white transition-colors text-sm">
                    Health AI
                  </Link>
                </li>
                <li>
                  <Link href="/terms-privacy-policy" className="text-slate-300 hover:text-white transition-colors text-sm">
                    Privacy Policy & Terms
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 4: Contact */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Contact</h3>
              <ul className="space-y-3">
                <li className="flex items-start space-x-2 text-slate-300 text-sm">
                  <Phone className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span>+91 9911090091</span>
                </li>
                <li className="flex items-start space-x-2 text-slate-300 text-sm">
                  <Mail className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span>go@healthyowl.in</span>
                </li>
                <li className="flex items-start space-x-2 text-slate-300 text-sm">
                  <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                  <span>Gurgaon, India</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-6 border-t border-slate-800 text-center">
            <p className="text-slate-400 text-sm">
              © 2025 The Owl Co. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
